/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as HXKLineAndBarLayerSpec } from '../../../../layer/preset/hxKLine/hxKLineAndBar';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

type HXKLineAndBarLayerType = StandardChartLayerSpec & HXKLineAndBarLayerSpec & ILayerTypeSpec;

// 创建K线叠加柱状图数据类型验证器
const validateHXKLineAndBarDataTypes = createDataTypeValidator('hxKLineAndBar', [
  { field: 'x', type: 'date' },
  { field: 'y', type: 'number' }
]);

// 创建K线叠加柱状图编码验证器
const validateHXKLineAndBarEncoding = createEncodingValidator([{ field: 'x' }, { field: 'y' }]);

// 额外的检查函数 - 验证股票配置
const additionalHXKLineAndBarChecks = (layer: HXKLineAndBarLayerType) => {
  // 检查stocks配置
  if (!layer.stocks || !Array.isArray(layer.stocks) || layer.stocks.length === 0) {
    utils.logger.warn(
      'warning',
      `The "stocks" configuration is required for "${layer.type}" layer`
    );
    layer.__isEncodingValid = false;
  } else {
    // 检查每个股票配置是否有效
    layer.stocks.forEach((stock, index) => {
      if (!stock.code || !stock.market) {
        utils.logger.warn(
          'warning',
          `Invalid stock configuration at index ${index} for "${layer.type}" layer`
        );
        layer.__isEncodingValid = false;
      }
    });
  }
};

// 创建并导出K线叠加柱状图处理器
export const hxKLineAndBar = createLayerProcessor<HXKLineAndBarLayerType>(
  'hxKLineAndBar',
  validateHXKLineAndBarEncoding,
  validateHXKLineAndBarDataTypes,
  additionalHXKLineAndBarChecks
);
